
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, tap, observable, catchError, throwError, forkJoin, of } from 'rxjs';
import { Control } from 'src/models/control';
import { User } from 'src/models/user';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { VehicleRelationship } from 'src/services/api-services/api-interfaces/vehicleRelationship.interface';
import { APIVehicleRelationship } from 'src/services/api-services/api-vehicle-relationship.service';
import { HelperService } from 'src/services/helperService';
import { ClientsComponent } from '../../clients.component';
import { ValidationErrors } from '@angular/forms';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';



const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};

const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};

@Component({
    selector: 'app-creation-clients',
    templateUrl: './creation-clients.component.html',
    styleUrls: ['./creation-clients.component.sass'],
    standalone: false
})

export class CreationClientsComponent implements OnInit {


  onAddControlClick = (param: string): void => {};
  isLoadingSave:boolean = true
  user:User= this.helperService.user
  id=  this.user.countryId
  documentType$: Observable<any[]> =  new Observable<any[]>();
  relationchip$: Observable<any[]> =  new Observable<any[]>();
  graphDropdowns$: Observable<any[]> =  new Observable<any[]>();
  vehicleData:any[] = [];
  personTypes: any[] = [];
  documentTypesByPersonType: any[] = [];
  vehicleBrands: any[] = [];
  vehicleBrandOptionsByRow: any[][] = [];
  vehicleModelsByRow: any[][] = [];
  vehicleModelOptionsByRow: any[][] = [];
  selectedVehicleBrandIdByRow: Array<number | null> = [];
  vehicleBrandInvalidByRow: boolean[] = [];
  vehicleModelInvalidByRow: boolean[] = [];


  constructor(
    @Inject(MAT_DIALOG_DATA)
    public client: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    public helperService: HelperService,
    public APIServicetypeDocument: APIDocumentTypeService,
    public VehicleRelationshipService: APIVehicleRelationship,
    public customerBasicDataService: APICustomerBasicDataService,
    public brandsService: APIBrandsService,
    public vehicleDataService: VehicleDataService,
    public dialogRef: MatDialogRef<ClientsComponent>,
  ) { }


  controls: Control[] = [
    {
      icon: 'bi bi-plus-lg',
      description: 'Add Workshops',
      action: this.onAddControlClick,
    },
  ];

  ngOnInit(): void {
    this.dataLoading()
    this.loadPersonTypes();
    this.watchPersonTypeChanges();
    this.loadVehicleBrands();
  }

  //This function allows me that when I open the form it will bring the set values.
  dataLoading(){

    this.newClient.patchValue({
      FirstName : "",
      LastName: "",
      email: "",
      NumDoc: "",
      Phone: "",
      Address: "",
      SapCustomerId:"",
    })
      //Brings the drop-downs with the types of service and relationship with the vehicle
      this.graphDropdowns$ = forkJoin([
      this.documentType$=  this.APIServicetypeDocument.GetByCountryId(this.id)
      .pipe(
        catchError((error: any) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          // Handle validation error here
          console.error('Validation Error:', error);
          // Rethrow the error to propagate it downstream
          return throwError(() => error);
        })
      ),
      this.relationchip$= this.VehicleRelationshipService.getAllVehicleRelationships()
    ]);
  }

  //Create new vehicle information
  createVehicle() {
    this.vehicleData.push({
      VehicleId: 0,
      Plate:"",
      VIN:"",
      Color:"",
      ModelDescription:"",
      Brand:"",
      Mileage:""
    });
    const index = this.vehicleData.length - 1;
    this.vehicleBrandOptionsByRow[index] = [...this.vehicleBrands];
    this.vehicleModelsByRow[index] = [];
    this.vehicleModelOptionsByRow[index] = [];
    this.selectedVehicleBrandIdByRow[index] = null;
    this.vehicleBrandInvalidByRow[index] = false;
    this.vehicleModelInvalidByRow[index] = false;
  }

  //Check that in the parameters you have the information to enable the accept button.
  formsValidations(): boolean {
    if (this.hasInvalidVehicleBrandOrModel()) {
      return true;
    }
    let is_true = true;
    if(this.vehicleData){
    this.vehicleData.forEach(vehicle=>{
      if(vehicle.Plate !== ''){is_true = false}
      else{is_true = true}
      if(vehicle.VIN !== ''){is_true = false}
      else{is_true = true}
      if(vehicle.Mileage !== ''){is_true = false}
      else{is_true = true}
    })}
    if(!is_true){
    const isFormValidationInvalid = this.newClient!.invalid
    return isFormValidationInvalid
  }else{return true; }


  }


  //This function sends the necessary information from the form to the backend and also shows the respective toast if the information was saved or not.
  onSaveCreateclient(){
    this.isLoadingSave = false;
    let clientJson ={
      CustomerId:0,
      SapCustomerId:this.newClient.value.SapCustomerId,
      Identification: this.newClient.value.NumDoc,
      DocumentType: this.newClient.value.typeDoc,
      PersonTypeId: this.newClient.value.tipoDePersona,
      FirstName: this.newClient.value.FirstName,
      LastName: this.newClient.value.LastName,
      Email: this.newClient.value.email,
      Phone: this.newClient.value.Phone,
      Address:this.newClient.value.Address,
      RelationshipVehicleId: this.newClient.value.OwnerRelation,
      Vehicles: this.vehicleData
    }
    this.customerBasicDataService.postCreateCustomer(clientJson)
    .pipe(
      tap((response) => {
        if (response.message === "Customer Created Successfully") {
          const translateTextSuccess = this.translate.instant("ToastCreateClient", { User: String(this.newClient.value.FirstName) + " " + String(this.newClient.value.LastName) });

          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =translateTextSuccess

          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)

          this.isLoadingSave = true;
          this.dialogRef.close("refreshCustomer");
        }
      })
    ).subscribe(
      {
        error: (failed) => {
          // Validation 401 error
          if(failed.status === 401){
            this.helperService.logoutToken()
          }

          const errorMessage = failed.error
          let translateTextError = ''


          if (errorMessage.includes("The identification already exists")){
            translateTextError = this.translate.instant("ToastErrorCreateClientExists",{Identification:String(this.newClient.value.NumDoc)});
          } else{
            translateTextError = this.translate.instant("ToastErrorCreateClient");
          }

        this.helperService.showAlert =true
        this.helperService.typeAlert ="error"
        this.helperService.messageAlert =translateTextError

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)


          this.dialogRef.close();
        },
      }
    )
  }

  //Establishes the new customer's reactive form and performs the necessary validations
  newClient = this.fb.group({
    FirstName:["", [ Validators.required,noSpecialCharsValidator]],
    LastName:["", [ Validators.required,noSpecialCharsValidator]],
    email:["", [ Validators.required,emailValidator,noSpecialCharsValidator ]],
    tipoDePersona:[null, [ Validators.required ]],
    typeDoc:[null, [ Validators.required]],
    NumDoc:["", [ Validators.required,noSpecialCharsValidator ]],
    Phone:["", [ Validators.required,noSpecialCharsValidator]],
    SapCustomerId:[""],
    Address:[""],
    OwnerRelation:[null, [ Validators.required ]]
  })

  markAsTouched() {
    this.typeDoc?.markAsTouched();
    this.typeDoc?.updateValueAndValidity();
  }

  get FirstName(): FormControl {
    return this.newClient.get('FirstName') as FormControl;
  }
  get LastName(): FormControl {
    return this.newClient.get('LastName') as FormControl;
  }
  get correoControl(): FormControl {
    return this.newClient.get('email') as FormControl;
  }

  get tipoDePersona(): FormControl {
    return this.newClient.get('tipoDePersona') as FormControl;
  }

  get typeDoc(): FormControl {
    return this.newClient.get('typeDoc') as FormControl;
  }
  get NumDoc(): FormControl {
    return this.newClient.get('NumDoc') as FormControl;
  }
  get Phone(): FormControl {
    return this.newClient.get('Phone') as FormControl;
  }
  get OwnerRelation(): FormControl {
    return this.newClient.get('OwnerRelation') as FormControl;
  }

  private loadPersonTypes(): void {
    this.APIServicetypeDocument.GetPersonTypeByCountryId(this.id)
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
          console.error('Error loading person types:', error);
          return of([]);
        })
      )
      .subscribe((personTypes: any[]) => {
        this.personTypes = personTypes ?? [];
      });
  }

  private loadDocumentTypesByPersonType(personTypeId: number | null | undefined): void {
    if (!personTypeId) {
      this.documentTypesByPersonType = [];
      this.newClient.get('typeDoc')?.reset(null);
      return;
    }

    this.APIServicetypeDocument
      .GetDocumentTypeByCountryIdByPersonId(
        this.helperService.user.countryId,
        Number(personTypeId)
      )
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
          console.error('Error loading document types:', error);
          this.documentTypesByPersonType = [];
          return of([]);
        })
      )
      .subscribe((docs: any[]) => {
        this.documentTypesByPersonType = docs ?? [];
        const currentDoc = this.newClient.get('typeDoc')?.value;
        const stillValid = this.documentTypesByPersonType.some(
          d => Number(d.typeId) === Number(currentDoc)
        );
        if (!stillValid) {
          this.newClient.get('typeDoc')?.reset(null);
        }
      });
  }

  private watchPersonTypeChanges(): void {
    this.newClient.get('tipoDePersona')?.valueChanges.subscribe((personTypeId) => {
      this.loadDocumentTypesByPersonType(personTypeId);
    });
  }

  private loadVehicleBrands(): void {
    this.brandsService.getBrandsByCountryId(this.helperService.user.countryId)
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
          console.error('Error loading vehicle brands:', error);
          return of([]);
        })
      )
      .subscribe((brands: any[]) => {
        this.vehicleBrands = brands ?? [];
      });
  }

  filterVehicleBrands(index: number, value: string | any): void {
    const filterValue = typeof value === 'string'
      ? value.toLowerCase()
      : value?.brandName?.toLowerCase() ?? '';
    this.vehicleBrandOptionsByRow[index] = this.vehicleBrands.filter(brand =>
      brand.brandName.toLowerCase().includes(filterValue)
    );
  }

  getBrandName(brand: any): string {
    if (typeof brand === 'string') {
      return brand;
    }
    return brand?.brandName ?? '';
  }

  onVehicleBrandInputChange(index: number, value: string | any): void {
    if (typeof value !== 'string') {
      return;
    }
    this.vehicleData[index].Brand = value;
    this.vehicleData[index].ModelDescription = '';
    this.selectedVehicleBrandIdByRow[index] = null;
    this.vehicleBrandInvalidByRow[index] = false;
    this.vehicleModelInvalidByRow[index] = false;
    this.vehicleModelsByRow[index] = [];
    this.vehicleModelOptionsByRow[index] = [];
    this.filterVehicleBrands(index, value);
  }

  private loadVehicleModelsByBrand(index: number, brandId: number): void {
    if (!brandId) {
      this.vehicleModelsByRow[index] = [];
      this.vehicleModelOptionsByRow[index] = [];
      return;
    }

    const plate = this.vehicleData[index]?.Plate
      ? String(this.vehicleData[index].Plate).toUpperCase()
      : '';
    this.vehicleDataService
      .getValidatedDataWithCountryAndbrand(plate, brandId)
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
          console.error('Error loading vehicle models:', error);
          this.vehicleModelsByRow[index] = [];
          this.vehicleModelOptionsByRow[index] = [];
          return of(null);
        })
      )
      .subscribe((customer: any) => {
        const models = customer?.vehicleModelInfo?.models ?? [];
        this.vehicleModelsByRow[index] = models;
        this.vehicleModelOptionsByRow[index] = models;
      });
  }

  filterVehicleModels(index: number, value: string): void {
    const filterValue = (value ?? '').toLowerCase();
    this.vehicleModelOptionsByRow[index] = (this.vehicleModelsByRow[index] ?? []).filter(model =>
      String(model).toLowerCase().includes(filterValue)
    );
  }

  onVehicleModelSelected(index: number, model: string): void {
    this.vehicleData[index].ModelDescription = model;
    this.vehicleModelInvalidByRow[index] = false;
  }

  onVehicleBrandSelected(index: number, brand: any): void {
    this.vehicleData[index].Brand = brand.brandName;
    this.vehicleData[index].ModelDescription = '';
    this.selectedVehicleBrandIdByRow[index] = brand.brandId;
    this.vehicleBrandInvalidByRow[index] = false;
    this.vehicleModelInvalidByRow[index] = false;
    this.vehicleModelsByRow[index] = [];
    this.vehicleModelOptionsByRow[index] = [];
    this.loadVehicleModelsByBrand(index, brand.brandId);
  }

  private normalizeVehicleText(value: any): string {
    return String(value ?? '').trim().toLowerCase();
  }

  private findBrandByName(brandName: string): any {
    const normalizedBrandName = this.normalizeVehicleText(brandName);
    return this.vehicleBrands.find(brand =>
      this.normalizeVehicleText(brand.brandName) === normalizedBrandName
    );
  }

  private findModelByName(index: number, modelName: string): string | undefined {
    const normalizedModelName = this.normalizeVehicleText(modelName);
    return (this.vehicleModelsByRow[index] ?? []).find(model =>
      this.normalizeVehicleText(model) === normalizedModelName
    );
  }

  validateVehicleBrand(index: number): void {
    const brandName = this.vehicleData[index]?.Brand;
    if (!brandName) {
      this.vehicleBrandInvalidByRow[index] = false;
      this.selectedVehicleBrandIdByRow[index] = null;
      return;
    }
    const brand = this.findBrandByName(brandName);
    if (!brand) {
      this.vehicleBrandInvalidByRow[index] = true;
      this.selectedVehicleBrandIdByRow[index] = null;
      this.vehicleData[index].ModelDescription = '';
      this.vehicleModelsByRow[index] = [];
      this.vehicleModelOptionsByRow[index] = [];
      return;
    }
    this.vehicleData[index].Brand = brand.brandName;
    this.vehicleBrandInvalidByRow[index] = false;
    if (this.selectedVehicleBrandIdByRow[index] !== brand.brandId) {
      this.selectedVehicleBrandIdByRow[index] = brand.brandId;
      this.vehicleData[index].ModelDescription = '';
      this.vehicleModelInvalidByRow[index] = false;
      this.loadVehicleModelsByBrand(index, brand.brandId);
    }
  }

  validateVehicleModel(index: number): void {
    const modelName = this.vehicleData[index]?.ModelDescription;
    if (!modelName) {
      this.vehicleModelInvalidByRow[index] = false;
      return;
    }
    const model = this.findModelByName(index, modelName);
    if (!model) {
      this.vehicleModelInvalidByRow[index] = true;
      return;
    }
    this.vehicleData[index].ModelDescription = model;
    this.vehicleModelInvalidByRow[index] = false;
  }

  hasInvalidVehicleBrandOrModel(): boolean {
    return this.vehicleData.some((vehicle, index) => {
      const brandName = vehicle?.Brand;
      const modelName = vehicle?.ModelDescription;
      const brandInvalid = !!brandName && !this.findBrandByName(brandName);
      const modelInvalid = !!modelName && !this.findModelByName(index, modelName);
      return brandInvalid || modelInvalid || this.vehicleBrandInvalidByRow[index] || this.vehicleModelInvalidByRow[index];
    });
  }      
}

